/**
 * SFrame253 — Beneficiary approvals (rebuilt with tracker).
 */

import SettlementStepPage from '../settlement/SettlementStepPage';
import BeneficiaryApprovalTracker from '../settlement/BeneficiaryApprovalTracker';
import { SETTLEMENT_PHASE_CONFIGS } from '../../utils/settlementFlowConfig';
import { useParams } from 'react-router-dom';
import { useSettlement } from '../../contexts/SettlementContext';

const step = SETTLEMENT_PHASE_CONFIGS.close.steps.find((s) => s.id === 'cls-2')!;

export default function SFrame253() {
  const { estateId } = useParams<{ estateId: string }>();
  const { isArchived } = useSettlement();

  return (
    <SettlementStepPage step={step} phase="close" overviewRoute="/sframe-250">
      <BeneficiaryApprovalTracker estateId={estateId ?? null} readOnly={isArchived} />
    </SettlementStepPage>
  );
}
